<app-login-content-container>
  <div class="d-none d-md-flex align-items-center h-100">
    <ng-container
      *ngTemplateOutlet="
        registrationFeedbackContent;
        context: { imgWidth: 400, imgHeight: 314 }
      "
    ></ng-container>
  </div>

  <div class="d-flex flex-column d-md-none">
    <ng-container
      *ngTemplateOutlet="
        registrationFeedbackContent;
        context: { imgWidth: 350, imgHeight: 257 }
      "
    ></ng-container>
  </div>

  <ng-template
    #registrationFeedbackContent
    let-imgWidth="imgWidth"
    let-imgHeight="imgHeight"
  >
    <!-- <img
      src="assets/images/registration_page.png"
      [width]="imgWidth"
      [height]="imgHeight"
    /> -->
    <!-- <div class="w-100 p-5"> -->
    <div class="w-100 text-center">
      <h3 style="font-size: 1.5em; font-weight: 700; text-align: center">
        {{ "user_registration_feedback.title" | translate }}
      </h3>

      <p class="mt-4">
        {{
          "user_registration_feedback.line_1"
            | translate : { email_address: username }
        }}
      </p>

      <p class="mt-4">{{ "user_registration_feedback.line_2" | translate }}</p>

      <p class="mt-4">{{ "user_registration_feedback.line_3" | translate }}</p>

      <div class="mt-4 d-flex justify-content-center">
        <uw-button
          [isMediumSize]="true"
          (buttonClick)="returnToSignIn()"
          btnLabel="{{'auth.return_to_sign_in' | translate}}"
        ></uw-button>
      </div>
    </div>
  </ng-template>
</app-login-content-container>
